import { Box, Grid, Typography } from "@mui/material";
import Header from "../Header";
import Footer from "../Footer";
import "../../styles/layouts.scss";
import { useTranslation } from "react-i18next";

const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;

//images
const subscribe = VISUALIZE__URL + "freetrail_bg.webp";
const ourservice1 = VISUALIZE__URL + "patient_education.webp";
const ourservice2 = VISUALIZE__URL + "pharmaceutical_marketing.webp";
const ourservice3 = VISUALIZE__URL + "clear_visualization.webp";
const ourservice4 = VISUALIZE__URL + "medical_professional_training.webp";
const ourservice5 = VISUALIZE__URL + "servicelist.webp";
const arrow = VISUALIZE__URL + "right_up.svg";

const PreloginServices = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <Box
        className="service_main"
        sx={{
          backgroundImage: `url(${subscribe})`,
        }}
      >
        <Typography
          className="title"
          variant="h4"
          fontWeight="bold"
          sx={{ textTransform: "uppercase" }}
        >
          {t("services")}
        </Typography>
        <Typography
          className="subtitle1"
          variant="subtitle1"
          sx={{ mb: 3, fontSize: "20px" }}
        >
          {t("comprehensive_medical_services")}
          <br />
          {t("for_your_health_and_wellness")}
        </Typography>
      </Box>

      {/* ========================SECTION: HERO =============== */}
      <Box>
        <Grid className="service-card" container spacing={3}>
          {[
            {
              title: "patienteducation",
              description: "prelogin_home_medical_concepts_explain",
              image: ourservice1,
            },
            {
              title: "medicalprofessional",
              description: "prelogin_home_animations_can_vividly",
              image: ourservice4,
            },
            {
              title: "pharmaceutical",
              description: "prelogin_home_drug_mechanisms",
              image: ourservice2,
            },
            {
              title: "clear_visualization_of_medical_device_functionality",
              description: "prelogin_home_many_medical_devices",
              image: ourservice3,
            },
            {
              title: "simplifying_complex_scientific_concepts",
              description: "prelogin_home_scientific_research",
              image: ourservice5,
            },
          ].map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                  background: "white",
                  height: "100%",
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-8px)",
                  },
                }}
              >
                {/* Service Image */}
                <Box
                  sx={{
                    position: "relative",
                    paddingTop: "75%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box
                    component="img"
                    src={service.image}
                    alt={service.title}
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "90%",
                      height: "9o%",
                      padding: "10px",
                      objectFit: "cover",
                      transform: "translate(-50%, -50%)", // Centering
                    }}
                  />

                  {/* Play button overlay */}
                  <Box className="back_playbtn">
                    <Box
                      className="back_playimg"
                      component="img"
                      src={arrow}
                      alt="Arrow"
                      sx={{
                        width: "80px", // Adjust size as needed
                        height: "50px",
                        marginLeft: "1px", // Offset for alignment
                      }}
                    />
                  </Box>
                </Box>

                {/* Service Content */}
                <Box sx={{ p: 3 }}>
                  <Typography
                    variant="h6"
                    color="#0080ff"
                    fontSize={"1.20rem"}
                    fontWeight="bold"
                    textAlign="center"
                    sx={{ mb: 1 }}
                  >
                    {t(service.title)}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    fontSize={"1rem"}
                    textAlign="justify"
                  >
                    {t(service.description)}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Footer />
    </>
  );
};
export default PreloginServices;
